export const areasOfActivityListSelector = state => state.areasOfActivity.areasOfActivityList
export const areaOfActivityMetaSelector = state => state.areasOfActivity.areaOfActivityMeta
